/**
 * Code runner — sends code to Brimi's backend (`/api/code/run`) which proxies
 * to JDoodle CompilerAPI. Backend handles credentials so no secrets in browser.
 *
 * Used for Java + any non-Python language. Python continues to use Pyodide
 * (faster, runs entirely in browser, no quota).
 */

import { api } from "@/lib/apiClient";

const SUPPORTED = new Set([
  "java",
  "python",
  "python3",
  "py",
  "c",
  "cpp",
  "c++",
  "javascript",
  "js",
]);

export const isPistonLanguage = (lang) => {
  if (!lang) return false;
  return SUPPORTED.has(lang.toLowerCase());
};

/**
 * Run code via backend → JDoodle. Returns { ok, stdout, stderr, error }.
 */
export const runOnPiston = async (code, language) => {
  const lang = (language || "").toLowerCase();
  if (!SUPPORTED.has(lang)) {
    return { ok: false, stdout: "", stderr: "", error: `Language '${language}' is not supported by the runner.` };
  }
  try {
    const res = await api.post("/code/run", { language: lang, code });
    return res.data;
  } catch (err) {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    if (status === 402) {
      return {
        ok: false,
        stdout: "",
        stderr: "",
        error: "Your free trial has ended — upgrade to keep running code.",
      };
    }
    if (status === 400) {
      return { ok: false, stdout: "", stderr: "", error: detail || "Invalid code." };
    }
    return {
      ok: false,
      stdout: "",
      stderr: "",
      error: "Couldn't reach the code runner. Please try again in a moment.",
    };
  }
};
